<template>
  <b-container class="mt-3">
    <b-card class="mt-4 mb-4">
      <standard-table ref="table"
                      search-id="recipients-search"
                      :items="items"
                      :fields="fields"
                      :search-place-holder="`${$tc('message.example', 1)}: AA999ZZ`"

                      :row-before-search="{cols: 12,sm: 12,md: 12,lg: 2,xl: 2,order: 1,orderSm: 1,orderMd: 1,orderLg: 3,orderXl: 3}"
                      :row-search="{cols: 12,sm: 12,md: 12,lg: 4,xl: 4,order: 1,orderSm: 2,orderMd: 2,orderLg: 1,orderXl: 1}"
                      :row-after-search="{cols: 12, sm: 12, md: 12, lg: 6, xl: 6, order: 2, orderSm: 3, orderMd: 3, orderLg: 2, orderXl: 2}"

                      :after-search="{cols: 12, sm: 12, md: 12, lg: 12, xl: 12}"

                      :row-pagination="{cols: 12, sm: 12, md: 6, lg: 5, xl: 5}"
                      :row-between-pagination="{cols: 12, sm: 12, md: 1, lg: 1, xl: 4}"
                      :row-per-page="{cols: 12, sm: 12, md: 5, lg: 3, xl: 2}"
                      :row-after-per-page="{cols: 12, sm: 12, md: 12, lg: 3, xl: 1}"

                      :search-label-horizontal="false"
                      fullWidth="true"
                      noContainerPadding="true"

                      @rowInfo="showInfo($event.item)"
                      @rowEdit="pushToEdit($event.item)"
                      @rowDelete="deleteSelected($event.item.id, `${$tc('message.recipients', 1)} ${$event.item.descr}`)">

        <b-container slot="row-before-search" class="mw-100 p-0">
          <b-row>
            <b-col class="mb-3" cols="12" sm="12" md="12" lg="12" xl="12">
              <!-- config[crud], create - read - update - delete -->
              <b-button v-on:click="pushToEdit()" class="b-c-blue float-right" id="add-recipient" v-if="config.c">{{$t('message.add')}}</b-button>
            </b-col>
          </b-row>
        </b-container>

        <b-container slot="row-after-per-page" class="mw-100 p-0">
          <b-row>
            <b-col>
              <b-button class="float-right mt-3 mt-md-0 mt-lg-0 mt-xl-0" id="excel-button" @click="$refs.table.excel($tc('message.recipients', 2))">Excel</b-button>
            </b-col>
          </b-row>
        </b-container>
      </standard-table>
    </b-card>

    <b-modal ref="infoModal" id="infoModal" :title="$t('info.infoModal')" size="lg">
      <b-container>
        <b-row>
          <b-col cols="12" sm="12" md="12" lg="12" xl="12">
            <div class="d-flex">
              <h6><b>{{$tc('message.description', 1)}}:</b></h6>
              <h6 class="ml-2">{{infoItem.descr}}</h6>
            </div>
          </b-col>
        </b-row>

        <b-row class="border-bottom border-c-green mb-3">
          <b-col>
            <font-awesome-icon icon="envelope"
                               id="mail-icon"
                               :class="infoItem.recipients && infoItem.recipients.length !== 0 ? 'c-green' : 'text-danger'"
            />
            <label class="c-green ml-1">
              {{$tc('message.list', 1)}} {{$tc('message.recipients', 2).toLowerCase()}}
            </label>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-list-group id="mail-list">
              <b-list-group-item v-for="mail in infoItem.recipients" :key="mail">
                <span class="float-left mt-1">{{mail}}</span>
              </b-list-group-item>
            </b-list-group>
          </b-col>
        </b-row>
      </b-container>

      <div slot="modal-footer" class="w-100 justify-content-end d-flex">
        <b-button class="b-c-green mr-3" v-on:click="closeInfoModal()">Ok</b-button>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import Vue from 'vue'
import { orderBy } from 'lodash'

export default {
  name: 'Recipients',
  created () {
    this.fetchData()
  },
  data () {
    const config = this.$route.meta.config

    return {
      config,
      items: [],
      fields: [],
      infoItem: {}
    }
  },
  mounted () {
    this.$root.$on('change-lang', () => {
      if (this.$el.isConnected) {
        this.getFields()
      }
    })
  },
  methods: {
    fetchData () {
      this.$root.$emit('activeLoader', true)
      this.getFields()
      this.getRecipients()
    },
    getRecipients () {
      Vue.myGet(this, '/recipients_list', 'recipients').then((recipients) => {
        const editedItems = []
        recipients.forEach(group => {
          const editedGroup = group
          editedGroup.mailString = ''
          group.recipients.forEach((recipient, index) => {
            editedGroup.mailString += `${recipient}${index + 1 === group.recipients.length ? '' : ', '}`
          })
          editedItems.push(editedGroup)
        })
        this.items = orderBy(editedItems, 'descr')
        this.$root.$emit('activeLoader', false)
      })
    },
    getFields () {
      this.fields = [
        // config[crud], create - read - update - delete
        { key: 'edit', label: '', hideInTable: !this.config.u && !this.config.r },
        { key: 'info', label: '', hideInTable: !this.config.u },
        { key: 'delete', label: '', hideInTable: !this.config.d },
        { key: 'descr', label: this.$tc('message.description', 1), sortable: true, sortDirection: 'desc' },
        { key: 'mailString', label: 'Email', sortable: true, sortDirection: 'desc', hideInTable: true }
      ]
    },
    pushToEdit (item) {
      item && item.id ? this.$router.push({ name: 'EditRecipients', params: { id: item.id } }) : this.$router.push({ name: 'EditRecipients', params: { id: 'new' } })
    },
    showInfo (item) {
      this.infoItem = item
      this.$refs.infoModal.show()
    },
    closeInfoModal () {
      this.$refs.infoModal.hide()
      this.infoItem = {}
    },
    deleteSelected (id, descr) {
      const obj = {
        path: `/recipients_list/${id}`,
        description: descr,
        redirect: this.$route.path
      }

      this.$root.$emit('deleteItem', obj, 1)
    }
  }
}
</script>

<style scoped>
  #mail-list {
    max-height: 400px;
    overflow: auto;
  }
</style>
